
//stylessheet
import React, { useState, useEffect, useContext } from "react";
import { Button, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from "../../contexts/AuthContext";

// import services
import GeneralService from '../../services/GeneralService';

// local imports
import GeneralNavbar from "../general/GeneralNavbar";
import Message from '../general/Message';
import Footer from '../general/Footer';
// import "./ClaimProfileStep2.css";

const CounsellorUnclaimedGatherInfo = (props) => {

  // contexts
  const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);
  const { NEXT_APP_URL } = useContext(AuthContext);

  // states
  const [requirementsList, setRequirementsList] = useState([false, false, false, false, false]);
  const [provider, setProvider] = useState({
    uniqueId: null
  });
  const [freeProviderSubscriptionPlan, setFreeProviderSubscriptionPlan] = useState({ serviceDetails: { modeOfServices: {} } });
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // useEffects
  useEffect(() => {
    scrollToTop();
    setIsLoading(true);
    try {
      GeneralService.getFreeProviderSubscriptionPlan()
        .then(data => {
          setFreeProviderSubscriptionPlan(data.freeProviderSubscriptionPlan);
          // console.log('Provider Subscriptions', data)
          setIsLoading(false);
        })
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  }, []);

  useEffect(() => {
    try {
      if (props.location.state) {
        setProvider(props.location.state.provider);
      }
    } catch (err) {
      Alert.error("Some error occured, please try again later or report support team.", {
        position: 'top-right',
        effect: 'slide'
      });
      // GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
    }
  }, [props.location.state]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  }

  // handle functions
  const handleChange = e => {
    try {
      if (e.target.name === "phone") {
        const re = /^[0-9\b]+$/;
        // if value is not blank, then test the regex
        if (e.target.value === '' || re.test(e.target.value)) {
          setProvider({ ...provider, [e.target.name]: e.target.value });
        }
      } else {
        setProvider({ ...provider, [e.target.name]: e.target.value });
      }
    } catch (err) {
      Alert.error("Some error occured, please try again later or report support team.", {
        position: 'top-right',
        effect: 'slide'
      });
      GeneralService.logError('at General ProviderSignup handlechange', 'Error in try catch block', err.stack);
    }
  }

  const handleSubmit = e => {
    e.preventDefault();
    try {
      if (requirementsList[0] && requirementsList[1] && requirementsList[2] && requirementsList[3] && requirementsList[4]) {
        setIsLoading(true);
        GeneralService.postClaimProfileRequest(provider)
          .then(data => {
            window.localStorage.removeItem('provider')
            scrollToTop();
            setMessage(data.message);
            setProvider({ email: "", firstName: "", lastName: "", phone: "" });
            setRequirementsList([false, false, false, false, false]);
            setIsLoading(false);
          });
      } else {
        scrollToTop();
        setMessage({ msgError: true, msgBody: "You must need to follow all requirements" });
      }
    } catch (err) {
      Alert.error("Some error occured, please try again later or report support team.", {
        position: 'top-right',
        effect: 'slide'
      });
      GeneralService.logError('at General ProviderSignup handleSubmit', 'Error in try catch block', err.stack);
      setIsLoading(false);
    }
  }

  return (
    <div>
      <GeneralNavbar history={props.history} />
      <div className="row">
        <div className="col-12 col-md-5 mx-auto my-4">
          <h4 style={{ color: "#384E73" }} className="mb-4 mx-2 text-center">Counsellor Information</h4>
          <div className="p-4" style={{ border: "4px solid #384E73", borderRadius: "10px" }}>
            <div>
              <span style={{ fontWeight: fontWeight.medium }}>Profile Link</span>
              <p style={{ wordBreak: "break-word" }}>https://www.umangwellness.com/counsellors/unclaimedProfile/{provider.uniqueId}</p>
            </div>
            <div>
              <h4>{provider.name}</h4>
              <h4>Psychologist</h4>
              <div>
                <p><i className="fas fa-map-marker-alt"></i> <span>{provider.city}, {provider.state} - {provider.country}</span></p>
              </div>
              <div className="mt-4">
                <span style={{ fontWeight: fontWeight.medium }}>Email</span>
                <p>{provider.email || "Information not available"}</p>
              </div>
              <div className="mt-4">
                <span style={{ fontWeight: fontWeight.medium }}>Degree/Licence</span>
                <p>{provider.degrees || "Information not available"}</p>
              </div>
              <div className="mt-4">
                <span style={{ fontWeight: fontWeight.medium }}>Contact Number</span>
                <p>{provider.phone || "Information not available"}</p>
              </div>
              <div className="mt-4">
                <span style={{ fontWeight: fontWeight.medium }}>Website</span>
                <p>{provider.website || "Information not available"}</p>
              </div>
            </div>
            <div className="separator"></div>
            <div className="mt-4 subscription--text">
              <span style={{ fontWeight: fontWeight.medium }}>Subscription Plan</span>
              <p>
                Your counsellor account comes with the following Basic plan
                (free). Upgrade to a higher tier to unlock more services and
                resources
              </p>
            </div>
            <div className="text-center px-2 py-3" style={theme.selectedSlotCard}>
              <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{freeProviderSubscriptionPlan.name}</h2>
              <p>{`₹${freeProviderSubscriptionPlan.amount / 100} / Month`}</p>
              <div>
                <p><i className='fas fa-check'></i> Upto {freeProviderSubscriptionPlan.serviceDetails.sessionBookingLimit} Session Bookings</p>
                <p><i className='fas fa-check'></i> Upto {freeProviderSubscriptionPlan.serviceDetails.clientLimit} Clients</p>
                <p><i className={`fas fa-${freeProviderSubscriptionPlan.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i> Call</p>
                <p><i className={`fas fa-${freeProviderSubscriptionPlan.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i> Chat</p>
                <p><i className={`fas fa-${freeProviderSubscriptionPlan.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i> Video</p>
                <p><i className={`fas fa-${freeProviderSubscriptionPlan.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i> In Person</p>
                <p><i className={`fas fa-${freeProviderSubscriptionPlan.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i> Create Client Subscription Plans</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-5 mx-auto my-4">
          <h4 style={{ color: "#384E73" }} className="mb-4 text-center">Fill your Information</h4>
          <div className="px-4">
            {message ? <Message message={message} /> : null}
            <div>
              <h5>Mandatory requirements</h5>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[0]} id="cb1" onChange={(e) => setRequirementsList({ ...requirementsList, 0: e.target.checked })} />
                <label className="form-check-label ml-2" htmlFor="cb1" style={{ cursor: "pointer" }}> I am a resident of India</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[1]} id="cb2" onChange={(e) => setRequirementsList({ ...requirementsList, 1: e.target.checked })} />
                <label className="form-check-label ml-2" htmlFor="cb2" style={{ cursor: "pointer" }}> I have at least a Masters Degree in psychology or related field</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[2]} id="cb3" onChange={(e) => setRequirementsList({ ...requirementsList, 2: e.target.checked })} />
                <label className="form-check-label ml-2" htmlFor="cb3" style={{ cursor: "pointer" }}> I have access to a reliable Internet connection to provide online services</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[3]} id="cb4" onChange={(e) => setRequirementsList({ ...requirementsList, 3: e.target.checked })} />
                <label className="form-check-label ml-2" htmlFor="cb4" style={{ cursor: "pointer" }}> I have practice experience of at least 3 years</label>
              </div>
              <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[4]} id="cb5" onChange={(e) => setRequirementsList({ ...requirementsList, 4: e.target.checked })} />
                <label className="form-check-label ml-2" htmlFor="cb5" style={{ cursor: "pointer" }}> I agree to all <a href={NEXT_APP_URL + '/termsconditions'}><u>Terms &#38; Conditions</u></a>, <a href={NEXT_APP_URL + '/privacypolicy'}><u>Privacy Policy</u></a> and <a href={NEXT_APP_URL + '/cookiepolicy'}><u>Cookie Policy</u></a> of Umang Wellness.</label>
              </div>
            </div>
            <Form className="m-4 p-4" style={{ boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "5px" }} onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="firstName" style={theme.formBodyText}>First Name</Label>
                <Input type="text" name="firstName" id="firstName" style={theme.formInput} onChange={handleChange} value={provider.firstName} placeholder="Firstname" required />
              </FormGroup>

              <FormGroup>
                <Label for="lastName" style={theme.formBodyText}>Last Name</Label>
                <Input type="text" name="lastName" id="lastName" style={theme.formInput} onChange={handleChange} value={provider.lastName} placeholder="Lastname" required />
              </FormGroup>

              <FormGroup>
                <Label for="email" style={theme.formBodyText}>Email address</Label>
                <Input type="email" name="email" id="email" value={provider.email} onChange={handleChange} style={theme.formInput} placeholder="sample@email.com" required />
              </FormGroup>

              <FormGroup>
                <Label for="phone" style={theme.formBodyText}>Phone</Label>
                <InputGroup>
                  <InputGroupAddon className="phoneAddon" addonType="prepend">+91</InputGroupAddon>
                  <Input type="text" maxLength="10" minLength="10" name="phone" id="phone" value={provider.phone} onChange={handleChange}
                    style={{ borderRadius: "0 10px 10px 0" }} placeholder="9875643210" required />
                </InputGroup>
              </FormGroup>

              <Button className="mt-3" type="submit" style={theme.formSubmit} disabled={isLoading}>
                {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Request to Claim Profile
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CounsellorUnclaimedGatherInfo;